


















import { Component, Vue } from "vue-property-decorator";
import GrpTagChoice from "@/interfaces/GrpTagChoice";

@Component
export default class GuestPanel extends Vue {
  tag = "";
  init(choice: GrpTagChoice | null) {
    this.tag = choice?.tag as string;
  }
  onGuests() {
    this.tag = "guests";
    this.notify();
  }
  onNoGuests() {
    this.tag = "no_guests";
    this.notify();
  }
  private notify() {
    const choice: GrpTagChoice = {
      tag: this.tag,
      isValid: true,
      type: "scalar",
    };
    this.$emit("choice", choice);
  }
}
